export enum ReferralDaysEnum {
    From1To7DaysDescription = '1-7 Days',
    From1To7Days = 1,
    From8To30DaysDescription = '8-30 Days',
    From8To30Days = 2,
}
